var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-layout"},[_c('no-ssr',[_c('actBar',{on:{"close":_vm.getPlaceholderHeight}})],1),_vm._v(" "),_c('nuxt'),_vm._v(" "),_c('GlobalSlot'),_vm._v(" "),_c('HomeFooter'),_vm._v(" "),_c('no-ssr',[_c('Login'),_vm._v(" "),_c('actFloatBar')],1),_vm._v(" "),_c('Sidebar'),_vm._v(" "),_c('PublicSlot')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }